export default __webpack_public_path__ + "static/media/5067.52730991.png";